import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Grid, Col, Button, FormGroup, FormControl, Panel } from 'react-bootstrap'
import * as helpers from '../lib/HelperFunctions'
import {Link} from 'react-router'

// Styles
import './css/firebaseui-styling.global.css' // Import globally.
import '../containers/css/Login.css'

class Login extends Component {
    constructor(props) {
        super(props)
        this.resetState = this.resetState.bind(this)
        this.state = {
            email: '',
            emailValid: false,
        }
    }

    resetState() {
      if(this){
        this.setState({
            email: '',
        })
      }
    }
    handleForgotPassword(){
      const {email} = this.state
      const {stores} = this.props
      const {store, authStore} = stores
      let thing = this

      store.infoAlert = 'Resetting Password, check your inbox.'
      window.setTimeout(() => { 
          store.infoAlert = undefined
      }, 5000)
      authStore.sendPasswordResetEmail({email})
      .then((success) => {thing.resetState()})
      .catch((error) => {thing.resetState()})
    }
  onPressEnterToSubmit(e){
    if(e.charCode === 13) {
      if(this.state.emailValid)
        this.handleForgotPassword()
    }         
  }

  handleEmailChange(e) {
      this.setState({email: e.target.value})
      if (helpers.validateEmail(e.target.value)){
          this.setState({emailValid:true})
      }else{
          this.setState({emailValid:false})
      }
  }
  handlePasswordChange(e) {
      this.setState({password: e.target.value})
  }
  
    render() {
      return (
          <Grid>
          <Col xs={10} xsOffset={1} md={4} mdOffset={4}>
            <div style={{display:'flex',justifyContent:'center'}}>
              <img src='/PreDo-logo.png' alt='PRE.DO' style={{width:'300px',height:'168px'}}/>
            </div>
            <div style={{display:'flex',justifyContent:'center', paddingBottom: '40px'}}>
              <h2>Login help</h2>
            </div>
            <Panel>
              <FormGroup controlId='formEmail'>
                <p style={{textAlign: 'center'}}>Enter you PRE.DO email to receive reset password link</p>
                <FormControl
                  type='email'
                  placeholder='youremail@mail.com'
                  onChange={(e) => this.handleEmailChange(e)}
                  onKeyPress={(e) => this.onPressEnterToSubmit(e)} 
                />
              </FormGroup>
              <div style={{display:'flex',justifyContent:'center'}}>
                <Button disabled={!this.state.emailValid} bsStyle='primary' onClick={(e) => this.handleForgotPassword(e)}>
                    Reset password
                </Button>
              </div>
            </Panel>
            <div style={{display:'flex',justifyContent:'center'}}>
              New to PRE.DO?
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Link to={{ pathname: '/signup' }} > 
                <b>Sign Up</b>
              </Link>
            </div>
            </Col>
          </Grid>
      )
  }
}

export default inject('stores')(observer(Login))



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.js